import { useRequest } from 'ahooks';
import {
  apiV2EnvMonitorDashboardInstantAvgPost,
  type V2EnvMonitorDashboardInstantAvgPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import dayjs from 'dayjs';
import { DEVICE_TYPE_MAP } from '../constants';

export type InstantAvgIndicator = NonNullable<V2EnvMonitorDashboardInstantAvgPostResponse['indicators']>[number];

interface UseInstantAvgAllParams {
  gasDeviceId?: number;
  waterDeviceId?: number;
  date: string;
  refreshKey: number;
}

interface UseInstantAvgAllResult {
  gasData?: V2EnvMonitorDashboardInstantAvgPostResponse;
  waterData?: V2EnvMonitorDashboardInstantAvgPostResponse;
  loading: boolean;
}

export const useInstantAvgAll = ({
  gasDeviceId,
  waterDeviceId,
  date,
  refreshKey,
}: UseInstantAvgAllParams): UseInstantAvgAllResult => {
  const dayStart = dayjs(date).startOf('day');
  const dayEnd = dayjs(date).endOf('day');

  const { data, loading } = useRequest(
    async () => {
      const [gasRes, waterRes] = await Promise.all([
        gasDeviceId
          ? apiV2EnvMonitorDashboardInstantAvgPost({
              deviceId: gasDeviceId,
              deviceType: DEVICE_TYPE_MAP.GAS,
              startTime: dayStart.valueOf(),
              endTime: dayEnd.valueOf(),
            })
          : Promise.resolve(undefined),
        waterDeviceId
          ? apiV2EnvMonitorDashboardInstantAvgPost({
              deviceId: waterDeviceId,
              deviceType: DEVICE_TYPE_MAP.WATER,
              startTime: dayStart.valueOf(),
              endTime: dayEnd.valueOf(),
            })
          : Promise.resolve(undefined),
      ]);
      return { gasRes, waterRes };
    },
    {
      ready: !!date && !!(gasDeviceId || waterDeviceId),
      refreshDeps: [gasDeviceId, waterDeviceId, date, refreshKey],
    }
  );

  return {
    gasData: data?.gasRes,
    waterData: data?.waterRes,
    loading,
  };
};
